import React from "react";
import styled from "styled-components";
import moment from "moment";
import { EventResponseStatusEnum } from "~/types/enums";
const Wrapper = styled.span`
  display: flex;
  font-size: ${_ref => {
  let {
    $scale,
    theme
  } = _ref;
  return $scale * theme.typography.fontStep;
}}rem;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.shape.borderRadius.primary;
}};
  min-width: ${_ref3 => {
  let {
    $scale
  } = _ref3;
  return $scale;
}}rem;
  max-width: ${_ref4 => {
  let {
    $scale
  } = _ref4;
  return $scale;
}}rem;
  min-height: ${_ref5 => {
  let {
    $scale
  } = _ref5;
  return $scale;
}}rem;
  max-height: ${_ref6 => {
  let {
    $scale
  } = _ref6;
  return $scale;
}}rem;
  ${_ref7 => {
  let {
    $responseStatus,
    $color,
    theme
  } = _ref7;
  switch ($responseStatus) {
    case EventResponseStatusEnum.NEEDS_ACTION:
      return `background: transparent; border: 3px solid ${$color}; color: ${$color};`;
    case EventResponseStatusEnum.ACCEPTED:
      return `background: ${$color}; color: ${theme.colors.background.primary};`;
    case EventResponseStatusEnum.DECLINED:
      return `background: transparent; border: 3px solid ${theme.colors.danger.main}; color: ${theme.colors.danger.main};`;
    case EventResponseStatusEnum.TENTATIVE:
      return `background: ${$color}; background-image: -webkit-linear-gradient(45deg,transparent,transparent 40%,rgba(0,0,0,.2) 40%,rgba(0,0,0,.2) 50%,transparent 50%,transparent 90%,rgba(0,0,0,.2) 90%,rgba(0,0,0,.2));
    background-image: linear-gradient(45deg,transparent,transparent 40%,rgba(0,0,0,.2) 40%,rgba(0,0,0,.2) 50%,transparent 50%,transparent 90%,rgba(0,0,0,.2) 90%,rgba(0,0,0,.2));
    background-size: 12px 12px; color: ${theme.colors.background.primary};`;
    default:
      return "";
  }
}}
  ${_ref8 => {
  let {
    $s,
    theme
  } = _ref8;
  return theme.spacing.resolve(theme, $s);
}};
`;
const Day = styled.i`
  font-size: 2em;
  line-height: 1em;
  font-style: normal;
  display: block;
  font-weight: ${_ref9 => {
  let {
    theme
  } = _ref9;
  return theme.typography.fontWeight.semiBold;
}};
`;
const Month = styled.i`
  font-style: normal;
  font-size: 9px;
  line-height: 1em;
  font-weight: ${_ref10 => {
  let {
    theme
  } = _ref10;
  return theme.typography.fontWeight.semiBold;
}};
`;
const DateBadge = _ref11 => {
  let {
    date,
    scale = 4,
    color = "#3f8cff",
    responseStatus = EventResponseStatusEnum.NEEDS_ACTION,
    s
  } = _ref11;
  const month = moment(date).format("MMM");
  const day = moment(date).format("D");
  return /*#__PURE__*/React.createElement(Wrapper, {
    $color: color,
    $scale: scale,
    $responseStatus: responseStatus,
    $s: s
  }, /*#__PURE__*/React.createElement(Month, null, month), /*#__PURE__*/React.createElement(Day, null, day));
};
export default DateBadge;